import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classNames from 'classnames';
import { TagSize, TagVariant } from '../../enums';
import styles from './Tag.module.scss';
const Tag = forwardRef(({ className, icon, screenReaderText, showBoldText = false, size = TagSize.Medium, text, variant = TagVariant.Light, ...restProps }, ref) => {
    return (_jsxs("div", { className: classNames(className, 'd-inline-block', styles.tag, styles[variant], styles[size], {
            'fw-semibold': showBoldText,
        }), ref: ref, ...restProps, children: [screenReaderText && _jsx("span", { className: "screenReaderOnly", children: screenReaderText }), _jsxs("span", { className: "d-flex  justify-content-center align-items-center", children: [icon && (_jsx("span", { className: "d-flex  justify-content-center align-items-center pr-0-5x", children: icon })), text] })] }));
});
Tag.displayName = Tag.name;
export { Tag };
